import { render, staticRenderFns } from "./TextInfoUser.vue?vue&type=template&id=120eb159&scoped=true&"
import script from "./TextInfoUser.vue?vue&type=script&lang=js&"
export * from "./TextInfoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120eb159",
  null
  
)

export default component.exports